<form [formGroup]="followUpForm" (ngSubmit)="onSubmit()" class="follow-up-form">
  <!-- <h3>Log Follow-Up</h3> -->
  <p>
    {{ t.JOB_TITLE }}: {{ jobTitle }} <br />{{ t.COMPANY }}: {{ companyName }} <br />{{ t.APPLICATION_ID }}: {{ applicationId }}
  </p>
  <div class="form-group">
    <label for="type">{{ t.LABEL_TYPE }}<span style="color: red">*</span></label>
    <select id="type" formControlName="type" required>
      <option value="" disabled>{{ t.OPTION_SELECT_TYPE }}</option>
      <option *ngFor="let t of types" [value]="t.value">{{ t.label }}</option>
    </select>
    @if (followUpForm.get('type')?.invalid && followUpForm.get('type')?.touched) {
      <div class="error">
        {{ t.ERROR_TYPE_REQUIRED }}
      </div>
    }
  </div>
  <div class="form-group">
    <label for="note">{{ t.LABEL_NOTE }}</label>
    <textarea
      id="note"
      formControlName="note"
      rows="3"
      [attr.placeholder]="t.PLACEHOLDER_OPTIONAL_NOTE"
    ></textarea>
  </div>
  <div class="form-actions">
    <button type="submit" [disabled]="followUpForm.invalid">{{ t.BUTTON_SUBMIT }}</button>
    <button type="button" (click)="onCancel()">{{ t.BUTTON_CANCEL }}</button>
  </div>
</form>
